import { NotifyLogin, notifyLoginSchema } from '@citibot/models';
import { Box, Grid, Grow, Typography } from '@mui/material';
import citiLogo from 'Assets/CitiBot.png';
import loginBg from 'Assets/hero.png';
import Button from 'Components/Button';
import Form from 'Components/Forms/Form';
import FormInput from 'Components/Forms/FormInput';
import useAuth from 'Hooks/useAuth';
import { useState } from 'react';
import { useNavigate } from 'react-router';

const initialValues = {
  email: '',
  otp: ''
};

const Login = () => {
  const [isOtpFieldVisible, setOtpFieldVisible] = useState<boolean>(false);
  const { loginLoading, isLoggedIn, handleOtpVerify, handlePasswordlessLogin } = useAuth();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/home`);
  };

  const handleToggleOtpField = () => {
    setOtpFieldVisible(true);
  };

  const handleSubmit = async (values: NotifyLogin) => {
    if (values.code) {
      handleOtpVerify(values.email, values.code ?? '', handleNavigate);
    }
  };

  const handleSendCode = async (values: NotifyLogin) => {
    handlePasswordlessLogin(values.email, handleToggleOtpField);
  };

  if (isLoggedIn) {
    console.log('isLoggedIn', isLoggedIn);
  }

  return (
    <Grid container data-testid="LoginPage" sx={{ height: '100vh' }} spacing={2}>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${loginBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '70%',
          backgroundPosition: 'center'
        }}
      />
      <Grid item xs={12} sm={8} md={5}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            padding: '10%'
          }}
        >
          <Grid container rowGap={2}>
            <Grid item xs={12}>
              <Box
                component="img"
                sx={{
                  width: '50%'
                }}
                src={citiLogo}
                alt="hero"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ mb: 2, mt: 5, fontWeight: 500 }}>
                Welcome to CITIBOT NOTIFY
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Form
                initialValues={initialValues}
                onSubmit={isOtpFieldVisible ? handleSubmit : handleSendCode}
                validationSchema={notifyLoginSchema}
              >
                <Grid container rowGap={2}>
                  <Grid item xs={12}>
                    <FormInput id="email" label="Email" />
                  </Grid>
                  {isOtpFieldVisible && (
                    <Grow in={isOtpFieldVisible}>
                      <Grid item xs={12}>
                        <FormInput id="code" label="OTP" />
                      </Grid>
                    </Grow>
                  )}

                  <Grid container item xs={12}>
                    <Button
                      variant="contained"
                      sx={{ mt: 2, mb: 4, borderRadius: 6, px: 8, fontWeight: 500, color: '#fff' }}
                      isLoading={loginLoading}
                      color="secondary"
                      type={'submit'}
                    >
                      {isOtpFieldVisible ? 'Submit' : 'Send Code'}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
